import './mobile-navigator.scss';
import React, { useEffect, useState } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import profileIcon from '../../assets/images/Profile.svg';
import favListIcon from '../../assets/images/mobile-menu/fav-list.svg';
import homeIcon from '../../assets/images/Home.svg';
import searchIcon from '../../assets/images/Search.svg';
import categoryIcon from '../../assets/images/Category.svg';
import { isPlatformBrowser } from '../../shared/services/general/general-service';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ImageGenerator from '../image-generator/image-generator';
import logo from '../../assets/images/bebin-logo.svg';
import bazaar from '../../assets/images/bazaar-logo-and-logotype 1.svg';
import googlePlay from '../../assets/images/en_badge_web_generic 1.svg';
import { useConfigApp } from '../../shared/services/general/app-context';
import Icon from '@material-ui/core/Icon';
import CloseIcon from '@material-ui/icons/Close';

function NavigatorItems() {
	const [value, setValue] = useState('');
	const [closeDWays, setCloseDWays] = useState(false);
	const [navigatorItems, setNavigatorItems] = useState([]);
	const history = useHistory();
	const { profile } = useSelector((state) => state.profileData);
	const configApp = useConfigApp();

	const isAndroidWebView = /android/i.test(navigator.userAgent || navigator.vendor || window.opera);

	useEffect(() => {
		const updatedNavigatorItems = [
			{
				title: JSON.stringify(profile) !== '{}' && profile !== undefined ? 'پروفایل' : 'ورود',
				icon: profileIcon,
				titleEn: 'icon-profile',
				url: JSON.stringify(profile) !== '{}' && profile !== undefined ? '/profile' : '/register',
			},
			{
				title: 'لیست شخصی',
				titleEn: 'icon-fav-list',
				icon: favListIcon,
				url: '/fav-list',
			},
			{
				title: 'دسته بندی',
				titleEn: 'icon-category',
				icon: categoryIcon,
				url: '/category',
			},
			{
				title: 'جستجو',
				icon: searchIcon,
				titleEn: 'icon-search',
				url: '/search',
			},
			{
				title: 'خانه',
				titleEn: 'icon-home',
				icon: homeIcon,
				url: '/',
			},
		];
		setNavigatorItems(updatedNavigatorItems);
	}, [profile]);

	const onHandleSubAlert = () => {
		setCloseDWays(true);
	};

	const downloadWays = () => (
		<div className="download-ways">
			<div className="close">
				<Icon component={CloseIcon} onClick={onHandleSubAlert} />
			</div>
			<div className="d-flex align-items-center">
				<div className="w">
					<ImageGenerator src={logo} name={configApp?.title || 'bebin'}/>
				</div>
				<div className="title">اپلیکیشن {configApp?.title}</div>
			</div>
			<div className="d-flex align-items-center" style={{ marginRight: 'auto' }}>
				<Link to={{ pathname: 'https://cafebazaar.ir/app/com.bebin.app' }} target="_blank" className="bazaar">
					<ImageGenerator src={bazaar} name={''} style={{ maxHeight: '32px', white: '50px' }} />
				</Link>
				<Link
					to={{ pathname: 'https://play.google.com/store/apps/details?id=com.bebin.app&pcampaignid=web_share' }}
					target="_blank"
					className="d-flex google-play"
				>
					<ImageGenerator src={googlePlay} name={''} style={{ maxHeight: '32px', white: '50px' }} />
				</Link>
			</div>
		</div>
	);

	const handleChange = (event, newValue) => {
		history.push(newValue);
		setValue(newValue);
	};

	useEffect(() => {
		if (isPlatformBrowser()) {
			setValue(window.location.pathname);
		}
	}, []);

	const listItems = navigatorItems.map((item, index) => (
		<BottomNavigation value={value} key={index} onChange={handleChange} showLabels>
			<BottomNavigationAction label={item.title} value={item.url} icon={<span className={`icon ${item.titleEn}`} />} />
		</BottomNavigation>
	));

	return (
		<div className="mob-nav">
			{isAndroidWebView && !closeDWays && (configApp?.titleEn === 'bebin' && !configApp?.sub_domain) && downloadWays()}
			<div id="navigator">{listItems}</div>
		</div>
	);
}

function Navigator() {
	return <NavigatorItems />;
}

export default Navigator;
